import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import {DndContext} from '@dnd-kit/core';
import {SortableContext} from '@dnd-kit/sortable';
import { arrayMove } from 'utils/array';

import OptionsAnswerButton from '../OptionsAnswerButton';

import s from './OrderAnswer.module.scss';

const cx = cn.bind(s);

const SortableItem = sortableElement(({
  label, color, isDraggable, ...attrs
}) => (
  <div className={cx('sortableItem', { isDraggable })} {...attrs}>
    <OptionsAnswerButton
      label={label}
      color={color}
      isDraggable={isDraggable}
    />
  </div>
));

const SortableContainer = sortableContainer(
  ({ children, ...attrs }) => <div {...attrs}>{children}</div>,
);

const OrderAnswer = ({
  children, color, className, value, options = [], length = 0, onChange, ...attrs
}) => {
  let normalizedList = Array.isArray(value) ? value : [];
  normalizedList = normalizedList.map((v) => options.find(
    (opt) => opt.value === v,
  ) || v);

  const handleOnSortStart = () => {
    document.body.style.cursor = 'grabbing';
  };
  const handleSortEnd = ({ newIndex, oldIndex }) => {
    onChange(arrayMove(value, oldIndex, newIndex));
    document.body.style.cursor = 'default';
  };
  const lengthValidationFailed = length && normalizedList.length < length;

  return (
    <div className={cx(className, 'wrapper')} {...attrs}>
      <SortableContainer
        useWindowAsScrollContainer
        shouldCancelStart={() => false}
        onSortStart={handleOnSortStart}
        onSortEnd={handleSortEnd}
      >
        {normalizedList.map((item, index) => (
          <SortableItem
            key={item.value}
            label={item.label}
            color={color}
            index={index}
            isDraggable
          />
        ))}
      </SortableContainer>
      {lengthValidationFailed && <h3 className={cx('font-bold italic', 'notice')}>Select more items</h3>}
    </div>
  );
};

OrderAnswer.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default OrderAnswer;
